import type { DateTime } from "luxon";
import type { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Tooltip } from "../tooltip";
import Style from "./ChartDateArea.module.scss";

type Props = {
	day: DateTime;
	labelEnabled?: boolean;
	label?: string;
	color?: string;
	/** The shift type named after the weekday; none for a whole-week label. */
	shiftType?: string;
	isHospitalDemo?: boolean;
	/** Area legend (ICU / TELE), rendered under the date. */
	legend?: ReactNode;
};
export const ChartDateArea: FC<Props> = ({ day, labelEnabled, shiftType, color, label, isHospitalDemo, legend }) => {
	const { t } = useTranslation();

	return (
		<div className={isHospitalDemo ? `${Style.dateAreaContainer} ${Style.demo}` : Style.dateAreaContainer}>
			{labelEnabled ? (
				<Tooltip
					id="caseLoad"
					text={t(labelEnabled ? "tooltip.caseLoad" : "")}
					showTooltip={true}
					component={<div className={Style.day}>{`${day.toFormat("cccc")} ${shiftType ? t(shiftType) : ""}`}</div>}
				/>
			) : (
				<div className={Style.day}>{`${day.toFormat("cccc")} ${shiftType ? t(shiftType) : ""}`}</div>
			)}
			<div className={labelEnabled ? Style.titleOverview : Style.title} style={{ color: color }}>
				{day.toFormat("MMM d")}
			</div>
			{labelEnabled && <p className={Style.label}>{label}</p>}
			{legend}
		</div>
	);
};
